import {
	faHouse,
	faMagnifyingGlass,
	faTemperatureHalf,
} from '@fortawesome/pro-solid-svg-icons'

import SearchRouter from '../Search/Router'
import Home from '../Home/Home'
import TemperatureRouter from '../Temperature/Router'
import { canShowUsecase } from '../../../helper/UserAccess'

export const TEMPERATURE_DEVICE_TYPE_GROUP = 'Temperature/IO'

const AllLinksArray = (moreThanOneTenant, usecaseAttributes) => {
	const { access, isTenantAddUser } = usecaseAttributes

	return [
		{
			to: 'home',
			name: 'Übersicht',
			icon: faHouse,
			show: true,
			element: Home,
			subPaths: false,
		},
		{
			to: 'search',
			name: 'Suche',
			icon: faMagnifyingGlass,
			show: moreThanOneTenant,
			element: SearchRouter,
			subPaths: true,
		},
		// { to: 'devices', name: 'Alle Geräte', icon: faLaptopMobile },
		{
			to: 'temperature',
			name: 'Temperaturübersicht',
			icon: faTemperatureHalf,
			show: canShowUsecase(access, TEMPERATURE_DEVICE_TYPE_GROUP, isTenantAddUser),
			element: TemperatureRouter,
			subPaths: true,
		},
		// {
		// 	to: 'electricity',
		// 	name: 'Energiemanagement',
		// 	icon: faBolt,
		// },
	]
}

export default AllLinksArray
